<template>
<div class="chapter">
<div class="inner_page">
<p class="fmpara"><a id="page_vii">Concerning the condition of the sons of men, God tests them, that they may see that they themselves are <i>like</i> animals.</a></p><a id="page_vii">
<p class="fmpara1">—Ecclesiastes 3:18</p>
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 06_Fm02.vue?5eb5f248